import { styled as muiStyled } from "@mui/material/styles";
import MuiButton from "@mui/material/Button";

import {
  Primary,
  Secondary,
  Focused,
  Red,
  Grey,
  White,
  White01,
  GreyStroke,
  Black,
  DarkGrey,
} from "src/styles/color";

const Button = muiStyled(MuiButton, {
  shouldForwardProp: (prop) => prop !== "sx",
})((props) => ({
  borderRadius: 16,
  textTransform: "none",
  boxShadow: "none",
  fontSize: "0.875rem",
  ":disabled": {
    cursor: "no-drop",
  },
  ":focus:not(:focus-visible)": {
    outline: "none",
    boxShadow: "none",
  },
  ":hover": {
    boxShadow: "none",
  },
  ":active": {
    boxShadow: "none",
  },
  ":focus": {
    outlineStyle: "solid",
    outlineWidth: "2px",
    outlineOffset: "0px",
    outlineColor: Focused,
    boxShadow: "none",
  },
  "&.Mui-disabled": {
    cursor: "no-drop",
    pointerEvents: "auto",
  },
  "&.MuiButton-contained": {
    backgroundColor: Primary,
    color: White,
    ":hover": {
      backgroundColor: Red,
    },
    ":disabled": {
      backgroundColor: White01,
      color: Grey,
      cursor: "no-drop",
    },
  },
  "&.MuiButton-secondary": {
    backgroundColor: Secondary,
    color: Primary,
    ":hover": {
      backgroundColor: Secondary,
      color: Red,
    },
    ":active": {
      backgroundColor: Secondary,
      color: Red,
    },
    ":focus": {
      backgroundColor: Secondary,
      color: Red,
    },
    ":disabled": {
      backgroundColor: White01,
      color: Grey,
      cursor: "no-drop",
    },
  },
  "&.MuiButton-outlined": {
    border: `1px ${props.color === "secondary" ? GreyStroke : Primary} solid`,
    color: Primary,
    // backgroundColor: Secondary,
    ":hover": {
      color: Red,
      backgroundColor: Secondary,
    },
    ":disabled": {
      border: `1px ${Grey} solid`,
      color: Grey,
      backgroundColor: White01,
      cursor: "no-drop",
    },
  },
  "&.MuiButton-text": {
    color: Primary,
    ":active": {
      color: Red,
    },
    ":hover": {
      color: Red,
      backgroundColor: "transparent",
    },
    ":disabled": {
      backgroundColor: "transparent",
      color: Grey,
      cursor: "no-drop",
    },
  },

  // custom
  "&.MuiButton-dark": {
    backgroundColor: Black,
    color: White,
    ":hover": {
      backgroundColor: "#313030",
    },
    ":disabled": {
      backgroundColor: White01,
      color: Grey,
      cursor: "no-drop",
    },
  },
  "&.MuiButton-textdark": {
    color: DarkGrey,
    padding: "8px 12px",
    ":active": {
      color: Grey,
    },
    ":hover": {
      color: Grey,
      backgroundColor: "transparent",
    },
    ":disabled": {
      backgroundColor: "transparent",
      color: Grey,
      cursor: "no-drop",
    },
  },
  "&.MuiButton-success": {
    backgroundColor: "#00A63E",
    color: White,
    ":hover": {
      backgroundColor: "#007A2E",
    },
    ":disabled": {
      backgroundColor: "#186a36",
      color: Grey,
      cursor: "no-drop",
    },
  },
  "&.MuiButton-file": {
    color: Primary,
    borderColor: "#D8D8DC",

    [props.theme.breakpoints.down("sm")]: {
      fontSize: "0.75rem",
    },
  },
  "&.MuiButton-cancel": {
    color: Primary,
    borderColor: "#D8D8DC",
    width: "180px",
    height: "48px",
    marginRight: "12px",

    [props.theme.breakpoints.down("md")]: {
      height: "40px",
    },
    [props.theme.breakpoints.down("sm")]: {
      height: "32px",
      fontSize: "0.75rem",
    },
  },
  "&.MuiButton-submit": {
    width: "180px",
    height: "48px",
    color: White,
    backgroundColor: Primary,
    marginLeft: "12px",
    fontSize: "0.875rem",

    [props.theme.breakpoints.down("md")]: {
      height: "40px",
    },
    [props.theme.breakpoints.down("sm")]: {
      height: "32px",
      fontSize: "0.75rem",
    },

    ":hover": {
      backgroundColor: Red,
      color: White,
    },
    ":disabled": {
      backgroundColor: White01,
      color: Grey,
      cursor: "no-drop",
    },
  },
  "&.MuiButton-download": {
    color: Black,
    backgroundColor: White,
    border: `1px solid #D8D8DC`,
    width: "100%",
    height: "48px",
    fontSize: "0.875rem",

    [props.theme.breakpoints.down("md")]: {
      height: "40px",
      fontSize: "0.75rem",
    },
    [props.theme.breakpoints.down("sm")]: {
      height: "32px",
      fontSize: "0.75rem",
    },
  },
  "&.MuiButton-upload": {
    color: Primary,
    borderColor: Primary,
    // width: "200px",
    width: "100%",
    height: "48px",
    marginRight: "12px",
    fontSize: "0.875rem",

    [props.theme.breakpoints.down("md")]: {
      height: "40px",
    },
    [props.theme.breakpoints.down("sm")]: {
      height: "32px",
      fontSize: "0.75rem",
    },
  },
  "&.MuiButton-edit": {
    color: Primary,
    borderColor: Primary,
    width: "100px",
    height: "48px",
    padding: "0",

    [props.theme.breakpoints.down("md")]: {
      height: "40px",
    },
    [props.theme.breakpoints.down("sm")]: {
      height: "32px",
      fontSize: "0.75rem",
    },
  },

  "&.MuiButton-location": {
    width: "154px",
    height: "48px",
    borderRadius: "16px",
    padding: "4px 8px",

    [props.theme.breakpoints.down("md")]: {
      width: "125px",
      height: "40px",
      fontSize: "0.75rem",
      padding: "4px 8px",
    },
    [props.theme.breakpoints.down("sm")]: {
      width: "100%",
    },
  },
  "&.MuiButton-location-google-maps": {
    width: "200px",
    height: "48px",
    borderRadius: "16px",
    padding: "4px 8px",
    marginLeft: "12px",

    [props.theme.breakpoints.down("md")]: {
      width: "180px",
      height: "40px",
      fontSize: "0.75rem",
      padding: "4px 8px",
    },
    [props.theme.breakpoints.down("sm")]: {
      width: "100%",
      marginLeft: "0px",
      marginTop: "10px",
    },
  },

  "&.MuiButton-dashed": {
    backgroundColor: White,
    color: Black,
    border: `1px dashed ${Primary}`,
    ":hover": {
      backgroundColor: White01,
      color: Primary,
    },
    ":active": {
      backgroundColor: White01,
      color: Black,
    },
    ":focus": {
      backgroundColor: White01,
      color: Primary,
    },
    ":disabled": {
      backgroundColor: White01,
      color: Grey,
      cursor: "no-drop",
    },
  },

  [props.theme.breakpoints.down("md")]: {
    padding: "6px 16px",
    fontSize: "0.875rem",
    ".MuiButton-startIcon>*:nth-of-type(1)": {
      fontSize: "0.875rem",
    },
  },
  [props.theme.breakpoints.down("sm")]: {
    fontSize: "0.75rem",
  },
}));

export default Button;
